import { Waves } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMode } from '@/hooks/useMode';
import { cn } from '@/lib/utils';

export function RippleToggle() {
  const { mode, toggle } = useMode();
  const active = mode === 'water';
  const label = active ? 'Voltar ao modo tradicional' : 'Ativar modo água';

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => toggle('water')}
      aria-label={label}
      title={label}
      aria-pressed={active}
      className="rounded-full backdrop-blur"
    >
      <Waves className={cn('h-4 w-4 transition-opacity', active ? 'opacity-100' : 'opacity-40')} />
    </Button>
  );
}
